export default "__VITE_ASSET__CQnDr0KZ__"